export default __webpack_public_path__ + "static/courseFlyerFront-9febbfa1de4f8cc940ffaecb30aa5a1f.jpg";